<script>
export const DATA_REPRESENTATION_VIEWS = Object.freeze({
    PIE_CHART: 'piechart',
    TABLE: 'table',
});

const tabs = [
    {
        title: __('Virksomhed'),
        key: 'company',
    },
    {
        title: __('Kanal'),
        key: 'channel',
    },
    {
        title: __('Kategori'),
        key: 'category',
    },
    {
        title: __('Område'),
        key: 'area',
    },
];

</script>

<script setup>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { __ } from 'JIX/gettext';
import PieChart from './PieChart.vue';
import ChartTabs from './ChartTabs.vue';
import TableView from './TableView.vue';
import DsCheckSwitch from 'JIX/components/ds/DsCheckSwitch.vue';


const props = defineProps({
    dataView: {
        type: String,
        default: DATA_REPRESENTATION_VIEWS.PIE_CHART,
        validator: value => Object.values(DATA_REPRESENTATION_VIEWS).includes(value)
    },
    initialActiveTab: {
        type: String,
        default: 'company',
        validator: value => tabs.map(({ key }) => key).includes(value),
    },
});

const store = useStore();

const dataView = ref(props.dataView);
const viewModeSwitchValue = ref(dataView.value === DATA_REPRESENTATION_VIEWS.TABLE);

const initialActiveTabIndex = tabs.findIndex(tab => tab.key === props.initialActiveTab);

const emit = defineEmits(['dataRepresentationChange']);

async function handleDataViewChange() {
    if (!viewModeSwitchValue.value) {
        viewModeSwitchValue.value = true;
        dataView.value = DATA_REPRESENTATION_VIEWS.TABLE;
        emit('dataRepresentationChange', DATA_REPRESENTATION_VIEWS.TABLE);

    } else {
        viewModeSwitchValue.value = false;
        dataView.value = DATA_REPRESENTATION_VIEWS.PIE_CHART;
        emit('dataRepresentationChange', DATA_REPRESENTATION_VIEWS.PIE_CHART);
    }
}

function getJobadDistributionData(activeTab, topLimit) {
    const jobadDistributionData = store.state.searchResponse.data.jobadDistribution[activeTab];
    const dataset = jobadDistributionData.find(({ top_limit }) => top_limit === topLimit);
    return dataset;
}


</script>

<template>
    <div class="d-flex justify-content-between">
        <h2>{{ __('Fordeling af annoncerne') }}</h2>
        <DsCheckSwitch
            :model-value="viewModeSwitchValue"
            @update:model-value="handleDataViewChange()"
        >
            {{ __("Listevisning") }}
        </DsCheckSwitch>
    </div>
    <ChartTabs :initial-active-tab="initialActiveTabIndex" :tabs="tabs" v-slot="{ activeTab }">
        <PieChart
            v-if="dataView === DATA_REPRESENTATION_VIEWS.PIE_CHART"
            :key="activeTab"
            :dataset="getJobadDistributionData(activeTab.key, 8)"
        />
        <TableView
            v-else
            class="analysis-table"
            :dataset="getJobadDistributionData(activeTab.key, null)"
        />
    </ChartTabs>
</template>
